/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UniversalTaskHitSchema } from './universalTaskHitSchema';

export interface UniversalTaskGroupSchema {
  items: UniversalTaskHitSchema[];
  has_more: boolean;
}
